import api from '../services/api';

/**
 * Document types an employee can request (work certificate, salary certificate...).
 * The admin can rename them in French and English, remove them or add new ones,
 * so the list always comes from the server; the standard list below is only the
 * fallback used while it loads or if it cannot be reached.
 */
export const STANDARD_DOCUMENT_TYPES = [
  { type: 'work_certificate', nameFr: 'Attestation de Travail', nameEn: 'Work Certificate' },
  { type: 'salary_certificate', nameFr: 'Attestation de Salaire', nameEn: 'Salary Certificate' },
  { type: 'employment_certificate', nameFr: "Attestation d'Emploi", nameEn: 'Employment Certificate' },
  { type: 'resignation_certificate', nameFr: 'Attestation de Démission', nameEn: 'Resignation Certificate' },
  { type: 'internship_certificate', nameFr: 'Attestation de Stage', nameEn: 'Internship Certificate' },
].map((t) => ({ ...t, active: true, standard: true }));

export const fetchDocumentTypes = async () => {
  try {
    const data = await api.get('/attestations/types');
    return Array.isArray(data) && data.length > 0 ? data : STANDARD_DOCUMENT_TYPES;
  } catch {
    return STANDARD_DOCUMENT_TYPES;
  }
};

const prettify = (key) => String(key || '').replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());

/** Name of a type in the given language ('fr' or 'en'); removed types keep their name. */
export const documentTypeName = (types, key, lang = 'en') => {
  const found = (types || []).find((t) => t.type === key);
  if (!found) return prettify(key);
  return String(lang).toLowerCase().startsWith('fr') ? found.nameFr : found.nameEn;
};

/** "English name (French name)", for screens that are not tied to one document language. */
export const documentTypeBothNames = (type) =>
  (type.nameEn === type.nameFr ? type.nameFr : `${type.nameEn} (${type.nameFr})`);

/** Types that can still be requested, as `<select>` options. */
export const documentTypeOptions = (types, lang) =>
  (types || []).filter((t) => t.active).map((t) => ({
    value: t.type,
    label: lang ? documentTypeName(types, t.type, lang) : documentTypeBothNames(t),
  }));
